import { getJobListings } from "app/api/job_api";
import { useQuery } from "@tanstack/react-query";

// Add a helper function to format searchTerm based on search mode
const formatSearchTerm = (searchTerm, searchMode) => {
  const trimmedSearch = searchTerm?.trim() || "";
  switch (searchMode) {
    case "company":
      return { searchQuery: "", companyName: trimmedSearch };
    case "job":
      return { searchQuery: trimmedSearch, companyName: "" };
    default:
      return { searchQuery: trimmedSearch, companyName: trimmedSearch };
  }
};

const useGetJobs = ({
  sortOrder,
  column,
  limit,
  offset,
  searchTerm,
  searchMode = "all", // Can be 'job', 'company', or 'all'
  id,
  type,
  exp,
  salary,
  skill,
  location,
  city,
  state,
  company,
  visibility,
  isExpired,
  fetchCompanyLogo = false,
  enabled = true,
  select = (data) => data,
  staleTime = 30000,
  refetchOnMount = true,
  ...rest
}) => {
  // Format search parameters based on search mode
  const { searchQuery, companyName } = formatSearchTerm(searchTerm, searchMode);

  // Ensure arrays for multiple-select filters
  const typeArray = Array.isArray(type) ? type : [];
  const locationArray = Array.isArray(location) ? location : [];
  const skillQuery = skill?.trim() || "";

  return useQuery({
    queryKey: [
      "job_listings",
      sortOrder,
      column,
      limit,
      offset,
      searchQuery,
      companyName,
      typeArray,
      exp,
      skillQuery,
      salary,
      city,
      state,
      rest,
      locationArray,
      visibility,
      company,
      isExpired,
      searchMode
    ],
    queryFn: () =>
      getJobListings(
        sortOrder,
        column,
        limit,
        offset,
        searchQuery,
        id,
        typeArray,
        exp,
        skillQuery,
        locationArray,
        city,
        state,
        salary,
        visibility,
        company,
        companyName,
        fetchCompanyLogo,
        isExpired
      ),
    enabled: enabled,
    select,
    staleTime,
    refetchOnMount: refetchOnMount
  });
};

export default useGetJobs;
